<div class="tw-block tw-w-full tw-h-full tw-border-spacing-0 tw-overflow-hidden tw-font-body">
  <div class="tw-flex tw-h-full tw-flex-col tw-flex-nowrap tw-relative">
    <div class="tw-w-full tw-flex-initial">
      @if (title === 'Consultation' && (selectedChatType.get('PrivateMainConcernClass') === 'FACE' || selectedChatType.get('PrivateMainConcernClass') === 'HAIR')) {
        @if (!hideNavBar) {
          <consultation-chat-header [consultationSession]="selectedChatType"
            [regimenClass]="selectedChatType.get('PrivateMainConcernClass')"
            [isRegimenExpired]="isRegimenExpired"
            [botReplyInProgress]="ui.botReplyInProcess"
          (back)="back()"></consultation-chat-header>
        }
      } @else {
        <!-- default header -->
        @if (!hideNavBar) {
          <div class="tw-flex tw-items-center tw-justify-center tw-h-14 tw-relative tw-bg-black"
            [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}">
            <cs-icon class="tw-absolute tw-left-6 tw-top-4 tw-h-6 tw-w-6 tw-text-white"
              [iconName]="'arrow_back'"
            (click)="back()"></cs-icon>
            @if ('Consultation' !== title && this.selectedChatType.className  !== 'SupportTicket') {
              <div class="tw-font-body tw-text-white tw-ml-8"
                >
                {{title || selectedChatType?.get('title')}}
              </div>
            }
            @if ('Consultation' !== title && this.selectedChatType.className  === 'SupportTicket') {
              <div class="tw-font-body tw-text-white tw-ml-8"
                >
                {{selectedChatType?.get('ticketNumber')}}
              </div>
            }
            @if ('Consultation' === title && selectedChatType.get('PrivateMainConcernClass') === 'FACE') {
              <div class="tw-font-body tw-text-white"
              i18n="@@discoverSkin"> Discover clear & healthy skin </div>
            }
            @if ('Consultation' === title && selectedChatType.get('PrivateMainConcernClass') === 'HAIR') {
              <div class="tw-font-body tw-text-white"
              i18n="@@discoverHair"> Discover strong & healthy hair </div>
            }
          </div>
        }
      }
      <!--Chat Progress Bar-->
      @if (showConsultationProgressBar) {
        <chat-progress-bar stickyTopClass="tw-top-12"></chat-progress-bar>
      }
      @if (showNewCrossSellDiscountMessage) {
        @if (selectedChatType?.className === 'ConsultationSession') {
          <div class="tw-flex tw-items-center tw-justify-center tw-min-h-14 tw-relative tw-bg-orange-100"
            >
            @if (selectedChatType.get('PrivateMainConcernClass') === 'HAIR') {
              <div class="tw-font-body tw-text-200 tw-text-black tw-py-2 tw-px-6">
                <p i18n="@@getHairTreatmentKitWithDiscount">Get your hair treatment kit with an extra <span
                      class="tw-font-bold">₹{{ crossSellDiscount }}</span> off! Order before {{ crossSellDeadline |
                date: 'd MMMM' }} to avail offer.</p>
            </div>
          }
          @if (selectedChatType?.get('PrivateMainConcernClass') === 'FACE') {
            <div class="tw-font-body tw-text-200 tw-text-black tw-py-2 tw-px-6">
              <p i18n="@@getFaceTreatmentKitWithDiscount">Get your face treatment kit with an extra <span
                      class="tw-font-bold">₹{{ crossSellDiscount }}</span> off! Order before {{ crossSellDeadline |
                date: 'd MMMM' }} to avail offer.</p>
          </div>
        }
      </div>
    }
  }
</div>
<div class="tw-w-full tw-overflow-x-hidden tw-overflow-y-auto tw-flex-auto tw-relative tw-bg-gray-100 tw-bg-[url('https://cdn.cureskin.com/app/img/chat-bg.svg')] scrollFast"
  id="messageContainer"
  #messageContainer="">
  @if ((chatPayload && chatPayload.loading.old) || !chats.length) {
    <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-full tw-absolute tw-z-10 tw-p-[10px] tw-left-1/2 tw-top-4 -tw-translate-x-1/2 tw-shadow-z1"
      >
      <loading class="tw-scale-75"></loading>
    </div>
  }
  <div class="tw-w-full">
    @for (chat of chats; track $index) {
      <div class="tw-w-full tw-clear-both"
        title='{{chat.get("BotMetadata")}}'
        [id]="chat.id">
        @if (isChatVisible(chat)) {
          @if (chat.get("unreadMessageStart") >= 0) {
            <div class="tw-float-right tw-w-full tw-text-center tw-mt-2.5 tw-mb-2"
              #unreadMessageDivider=""
              >
              <div class="tw-font-medium tw-text-200 tw-py-2.5 tw-px-5 tw-rounded-6 tw-text-center tw-inline-block tw-m-auto tw-bg-white"
                i18n="@@unreadMessages">
                {{chat.get("unreadMessageStart")}} Unread Messages
              </div>
            </div>
          }
          @if ($index === 0 || chat.displayDate !== chats[$index-1].displayDate) {
            <div class="tw-w-full tw-text-center"
              >
              <span class="tw-inline-block tw-w-40 tw-px-0 tw-py-0.5 tw-rounded-4 tw-uppercase tw-mt-2.5 tw-text-200 tw-tracking-wide tw-font-lexend tw-bg-gray-100">{{chat.displayDate}}</span>
            </div>
          }
          <chat-message
            [chat]="chat"
            [isLast]="$index === chats.length - 1"
            [isInternalUser]="isInternalUser"
            [allowAnimation]="allowAnimation"
            [selectedChatType]="selectedChatType"
            [user]="user"
            [allocatedDoctor]="allocatedDoctor"
            [isLatestMessage]="chat === latestMessage"
            [botReplyInProcess]="ui.botReplyInProcess"
            (assistantAction)="processAssistantAction($event.chat, $event.index, $event.input)"
            (imageCardClick)="handleImageCardClick($event)"
            (imageModalOpen)="openImageModal($event)"
            (imagesExpand)="expandImages($event)"
            (bothSideFaceImageClick)="openImageFromBothSidePhotos($event)">
          </chat-message>
        }
      </div>
    }
    @if (showReportGettingReadyBanner) {
      <div class="tw-w-full tw-mb-8">
        <report-getting-ready></report-getting-ready>
      </div>
    }
    @if (ui.botReplyInProcess) {
      <div class="tw-min-w-20 w20 mB20 tw-w-1/5 tw-clear-both tw-float-left tw-bottom-3 tw-my-5 tw-mx-4 tw-bg-white tw-px-[15px] tw-py-[10px] tw-relative tw-rounded-tl-5 tw-rounded-tr-5 tw-rounded-br-5 tw-rounded-bl-0 tw-origin-left tw-shadow-z1 tw-animate-anim_scale"
        >
        <div
          class="dot1 tw-inline-block tw-w-1.5 tw-h-1.5 tw-rounded-full tw-mt-[3px] tw-mx-[5px] tw-mb-0 tw-bg-gray-500 ">
        </div>
        <div
          class="dot2 tw-inline-block tw-w-1.5 tw-h-1.5 tw-rounded-full tw-mt-[3px] tw-mx-[5px] tw-mb-0 tw-bg-gray-500 ">
        </div>
        <div
          class="dot3 tw-inline-block tw-w-1.5 tw-h-1.5 tw-rounded-full tw-mt-[3px] tw-mx-[5px] tw-mb-0 tw-bg-gray-500 ">
        </div>
      </div>
    }
  </div>
  @if (!ui.chatInputEnable) {
    <div class="tw-clear-both"
      >
      @if (timer.minutes >= 0 ) {
        <div class="tw-flex tw-items-center tw-flex-wrap tw-my-0 tw-mx-3 tw-pt-1.5 tw-px-0 tw-pb-3"
          (click)="openActiveSessionRegimen()">
          <div
            class="tw-text-center tw-bg-white tw-tracking-[0.5px] tw-rounded-5 tw-rounded-bl-0 tw-py-2 tw-px-6 tw-text-blue-500 tw-shadow-z1">
            <div class="tw-min-h-10 tw-flex tw-items-center tw-justify-center tw-flex-wrap">
              <div class="tw-inline-block"
              i18n="@@getYourTreatmentTime"> Get your treatment kit in </div>
              <div class="tw-inline-block">
                <div class="tw-inline-block tw-pl-[10px]">{{timer.minutes}} Min</div>
                <div class="tw-min-w-7 tw-text-right tw-py-0 tw-px-1 tw-inline-block">
                  {{timer.seconds > 9 ? timer.seconds : '0'+timer.seconds}}
                </div>
                <div class="tw-inline-block">Sec</div>
              </div>
            </div>
            @if (timer.minutes < 0) {
              <div class="tw-flex tw-justify-center tw-items-center"
                >
                <loading class="tw-scale-[0.8]"></loading>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (callBackExperimentEnable && disableChatInput) {
    <div class="tw-pb-4 tw-w-full tw-clear-both"
    ></div>
  }
  @if (!callBackExperimentEnable && selectedChatType?.get("status") === appConfig.Shared.Ticket.status.Completed) {
    <div class="tw-pb-4 tw-w-full tw-clear-both"
      >
    </div>
  }
</div>
@if (rebrandedTextInputVisible) {
  <div class=" tw-sticky tw-bottom-0 tw-bg-gray-100 tw-w-full tw-h-fit tw-bg-cover">
    <ng-container *ngTemplateOutlet="rebrandedTextInput"></ng-container>
  </div>
}
<div class="tw-w-full tw-flex-[0_1_0] tw-bg-gray-100">
  @if (ui.chatInputEnable && !ui.botReplyInProcess) {
    <div class="tw-flex tw-w-full tw-items-center tw-py-[15px] tw-px-3"
      >
      <div class="tw-relative tw-mr-3 tw-flex-grow tw-bg-white tw-rounded-full tw-flex tw-items-center">
        <input class="secondary tw-flex-grow"
          [(ngModel)]="chatPayload.input"
          placeholder="Type your message here"
          i18n-placeholder="@@chatPlaceholder"
          autocomplete="off"
          [class.tw-text-teal-500]="isVoiceListening"
          (ngModelChange)="dismissVoiceTooltip()"
          (blur)="onKeyBoardOpen()"
          (click)="onKeyBoardOpen()" />
        @if (isVoiceMicVisible) {
          <voice-mic-input class="tw-mr-3"
            [showTooltip]="showVoiceTooltip"
            (transcript)="onLegacyVoiceTranscript($event)"
            (stateChange)="onVoiceStateChange($event)"
          (tooltipShown)="dismissVoiceTooltip()"></voice-mic-input>
        }
      </div>
      <div class="tw-inline-block tw-w-[45px] tw-h-[45px]">
        <div class="tw-flex tw-items-center tw-justify-center tw-w-[45px] tw-h-[45px] tw-rounded-full tw-text-center tw-bg-white tw-shadow-z1 "
          (click)="saveUserResponse(null, chatPayload.input)"
          [ngStyle]="{'background': chatPayload.input ? '#fff' : '#fff'}">
          <em class="cs-icon-send tw-ml-1 tw-text-600"
          [ngStyle]='{ "color" : chatPayload.input ? "#26216e" : "#c3c3c3" } '></em>
        </div>
      </div>
    </div>
  }
  @if (ticketClosedDaysChecked && this.selectedChatType?.className === 'SupportTicket' && ([appConfig.Shared.Ticket.status.Completed, appConfig.Shared.Ticket.status.RequestClosure].includes(selectedChatType?.get('status'))) && !!selectedChatType?.get('completedAt') && !isInternalUser && !isTicketClosedBeforeTwoDays && !inTransitUser && !selectedChatType?.get('isFeedbackRestricted')) {
    <div class="tw-py-5 tw-px-4">
      @if (!this.selectedChatType.get('feedback') && !afterSaveFeedback) {
        <div class="tw-flex tw-items-center tw-bg-white tw-rounded-1 tw-p-4 tw-mb-4">
          <div class="tw-flex-1" i18n="@@wasThisHelpfull">Was this helpful?</div>
          <div class="tw-min-w-20 tw-flex tw-items-center tw-flex-wrap tw-justify-end">
            <em class="tw-text-600 tw-ml-[15px]"
              (click)="updateFeedback(true)"
            [ngClass]="{ 'cs-icon-like-filled tw-animate-anim_like tw-text-green-400': isHelpfull, 'cs-icon-like': !isHelpfull, 'tw-pointer-events-none': selectedChatType?.get('status') === appConfig.Shared.Ticket.status.Completed && isTicketClosedBeforeTwoDays}"></em>
            @if (callBackExperimentEnable) {
              <em
                class="tw-text-600 tw-ml-[15px]"
                (click)="updateFeedBackIfFalse()"
              [ngClass]="{ 'cs-icon-dislike-filled tw-animate-anim_like tw-text-red-400': isHelpfull === false, 'cs-icon-dislike': isHelpfull !== false, 'tw-pointer-events-none': selectedChatType?.get('status') === appConfig.Shared.Ticket.status.Completed && isTicketClosedBeforeTwoDays }"></em>
            }
            @if (!callBackExperimentEnable) {
              <em
                class="tw-text-600 tw-ml-[15px]"
                (click)="updateFeedback(false)"
              [ngClass]="{ 'cs-icon-dislike-filled tw-animate-anim_like tw-text-red-400': isHelpfull === false, 'cs-icon-dislike': isHelpfull !== false, 'tw-pointer-events-none': selectedChatType?.get('status') === appConfig.Shared.Ticket.status.Completed && isTicketClosedBeforeTwoDays }"></em>
            }
          </div>
        </div>
      }
      @if (afterSaveFeedback) {
        <div class="tw-flex tw-items-center tw-bg-white tw-rounded-[5px] tw-p-4 tw-mb-4 feedback"
          >
          <cs-icon class="tw-w-6 tw-h-6 tw-text-green-400"
          [iconName]="'check_circle'"></cs-icon>
          <div class="tw-flex-1 tw-ml-[10px]"
          i18n="@@thankYouForYourFeedback"> Thank You For Your Feedback </div>
        </div>
      }
    </div>
  }
  @if (selectedChatType?.get("status") === appConfig.Shared.Ticket.status.Completed && !callBackExperimentEnable) {
    <div class="tw-p-[15px] tw-bg-orange-500 tw-text-white tw-font-medium tw-text-center tw-text-300"
      i18n="@@thisQueryHasBeenClosed"> This conversation is marked as closed. If you have any other questions or
        issues, please open the <b>“Need Help”</b> section of our app to raise a new query. </div>
    }
    @if (!disableChatInput && selectedChatType?.get("status") === appConfig.Shared.Ticket.status.Completed && callBackExperimentEnable) {
      <div class="tw-p-[15px] tw-bg-teal-100 tw-text-black tw-font-medium tw-text-center tw-text-300"
        i18n="@@thisQueryHasBeenClosed"> This conversation is marked as closed. If you have any other questions or
        issues, please open the <b>“Need Help”</b> section of our app to raise a new query. </div>
      }
    </div>
  </div>
</div>
<ng-template #rebrandedTextInput>
  <div class="tw-w-full">
    <div class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-3 glass-morphism-effect">
      <div class="tw-flex-1 tw-rounded-2.5 tw-px-4 tw-py-2.5 tw-bg-white tw-shadow-[0_1px_4px_-1px_#d5d5d5] tw-flex tw-items-center tw-gap-2">
        <textarea
          #rebrandedChatTextarea
          class="tw-flex-1 tw-p-0 tw-rounded-none tw-text-300"
          style="border: none; min-height: 0px;"
          [(ngModel)]="rebrandedTextInputVal"
          [placeholder]="rebrandedTextInputPlaceholder"
          autocomplete="off"
          [class.tw-text-teal-500]="isVoiceListening"
          (ngModelChange)="dismissVoiceTooltip()"
          (focus)="onKeyBoardOpen()"
          cdkTextareaAutosize
          cdkAutosizeMinRows="0"
        cdkAutosizeMaxRows="3"></textarea>
        @if (isVoiceMicVisible) {
          <voice-mic-input [showTooltip]="showVoiceTooltip"
            (transcript)="onRebrandedVoiceTranscript($event)"
            (stateChange)="onVoiceStateChange($event)"
          (tooltipShown)="dismissVoiceTooltip()"></voice-mic-input>
        }
      </div>
      <div class="tw-flex tw-items-center tw-justify-center tw-w-[45px] tw-h-[45px] tw-rounded-full tw-shrink-0 tw-cursor-pointer"
        [ngClass]="rebrandedTextInputVal?.trim() ? 'tw-bg-black' : 'tw-bg-white tw-shadow-[0_1px_4px_-1px_#d5d5d5]'"
        (click)="sendRebrandedTextInput()">
        <em class="tw-ml-1 tw-text-[22px] cs-icon-send"
        [ngClass]="rebrandedTextInputVal?.trim() ? 'tw-text-white' : 'tw-text-black'"></em>
      </div>
    </div>
  </div>
</ng-template>
@if (multiImageData.length) {
  <multiImages
  [data]="multiImageData"></multiImages>
}
<file-picker (onFileChange)="onUploadReport($event)"
accept="image/jpeg,application/pdf"></file-picker>
@if (imageModal.open) {
  <pop-up
    [fullscreen]="true"
    [class]="'bdr-rad-10 '"
    [show]="imageModal.open"
    [triggerDismiss]="true">
    <div class="tw-block tw-border-spacing-0 tw-w-full tw-h-full tw-overflow-hidden">
      <div class="tw-flex tw-flex-col tw-flex-nowrap tw-h-full"></div>
      <div class="tw-flex-initial tw-w-full"
        #header="">
        <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
          <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10"
            (click)="closeImageModal()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
            [iconName]="'arrow_back'"></cs-icon>
          </div>
        </div>
      </div>
      <div class="tw-font-body tw-relativel tw-flex-1 tw-pb-5 tw-bg-gray-100"
        #content="">
        <div class="tw-relative tw-overflow-hidden">
          <div style="position: relative; width: 100%; height: 100%">
            <img [src]="imageModal.imageUrl"
              alt="Description"
              style="width: 100%; max-height: 100%; object-fit: contain" />
          </div>
        </div>
      </div>
    </div>
  </pop-up>
}
